import React, { FC } from 'react';
import { getTranslator } from '../../shared/i18n/getTranslator';
import { Card, Heading1, Link, Text } from '@blueprint/ui';
import searchTranslations from 'public/locales/en/search.json';

const t = getTranslator(searchTranslations);
const title = t('emailAll.successPageNotLoggedIn.title');
const linkText = t('emailAll.successPageNotLoggedIn.linkText');
const text = t('emailAll.successPageNotLoggedIn.text');

interface Props {
    isUserLoggedIn: boolean | null;
    createAlert: string | null;
}

export const EmailSent: FC<Props> = ({ isUserLoggedIn, createAlert }) => {
    return (
        <>
            {!isUserLoggedIn && (
                <Card>
                    <Heading1 size="5" data-testid="success-additional-heading">
                        {title}
                    </Heading1>
                    <Text data-testid="success-additional-text">
                        <Link
                            data-testid="success-additional-link"
                            href={createAlert ?? ''}
                        >
                            {linkText}
                        </Link>
                        {text}
                    </Text>
                </Card>
            )}
        </>
    );
};
